import { Component, OnInit } from '@angular/core';
interface ProjectDetails {
    category: string;
    title: string;
    subtitle: string;
    overview: string;
    features: string[];
    technologies: string[];
    results: string | string[]; // Accept either a string or an array of strings
    images: string[];
}
interface ProjectData {
    [key: string]: ProjectDetails;
}
@Component({
  selector: 'app-home-three',
  templateUrl: './home-three.component.html',
  styleUrls: ['./home-three.component.scss']
})

export class HomeThreeComponent implements OnInit {

  constructor() { }
  isResultsArray(
         results: string | string[] | undefined
     ): results is string[] {
         return Array.isArray(results);
     }
     currentFilter: string = "all";
     isModalOpen: boolean = false;
     selectedProject: ProjectDetails | null = null;
 
     // 3. Project data structure (from your JS object)
     projects: ProjectData = {
         // healthcare1: {
         //   category: 'Healthcare',
         //   title: 'Patient Management System',
         //   subtitle: 'Comprehensive EHR solution for modern healthcare facilities',
         //   overview: 'A fully integrated Electronic Health Records (EHR) system designed to streamline patient care, enhance clinical workflows, and ensure HIPAA compliance. The system provides a unified platform for managing patient information, scheduling, billing, and clinical documentation.',
         //   features: ['Secure patient data management with role-based access control', 'Integrated appointment scheduling with automated reminders', 'Real-time clinical documentation and charting', 'Insurance verification and billing management', 'Customizable reporting and analytics dashboard', 'Mobile-responsive design for on-the-go access'],
         //   technologies: ['React', 'Node.js', 'PostgreSQL', 'AWS', 'Docker', 'Redis'],
         //   results: 'Reduced administrative overhead by 40%, improved patient satisfaction scores by 25%, and achieved 100% HIPAA compliance.',
         //   images: [
         //     'https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=400&h=300&fit=crop',
         //     'https://images.unsplash.com/photo-1551190822-a9333d879b1f?w=400&h=300&fit-crop',
         //     'https://images.unsplash.com/photo-1581093458791-9f3c3250a8b0?w=400&h=300&fit-crop',
         //     'https://images.unsplash.com/photo-1530497610245-94d3c16cda28?w=400&h=300&fit-crop'
         //   ]
         // },
         healthcare1: {
             category: "Healthcare",
             title: "Healthcare Software & Digital Health Solutions",
             subtitle:
                 "Secure, scalable, and intelligent healthcare technology solutions.",
             overview:
                 "We deliver end-to-end healthcare technology solutions designed to improve patient care, streamline clinical workflows, and ensure regulatory compliance. Our healthcare platforms enable hospitals, clinics, and healthcare startups to manage operations efficiently while leveraging modern cloud, mobile, and AI-driven technologies.",
             features: [
                 "Secure patient data management with role-based access control",
                 "Integrated appointment scheduling with automated reminders",
                 "Real-time clinical documentation and charting",
                 "Insurance verification and billing management",
                 "Customizable reporting and analytics dashboard",
                 "Mobile-responsive design for on-the-go access",
             ],
             technologies: [
                 "React",
                 "Angular",
                 "MVC",
                 ".NET",
                 "Azure",
                 "MS SQL Server",
                 "HIPAA",
                 "Node.js",
                 "Github CICD",
             ],
             results: [
                 "Streamlined administrative processes and reduced manual workload",
                 "Improved patient engagement and satisfaction",
                 "Enhanced data security and compliance with healthcare regulations",
                 "Enabled efficient clinical workflows and better decision-making",
                 "Provided scalable, future-ready healthcare technology solutions",
             ],
 
             images: [
                 "assets/img/Portfolio/Healthcare1.png",
                 "assets/img/Portfolio/Healthcare2.png", 
                 "assets/img/Portfolio/Healthcare3.png",
                 "assets/img/Portfolio/Healthcare4.png",
             ],
         },
         healthcare2: {
             category: "Healthcare",
             title: "Telemedicine Platform",
             subtitle:
                 "Secure virtual healthcare connecting patients and providers beyond boundaries",
             overview:
                 "A secure and scalable telemedicine platform that enables healthcare providers to deliver real-time virtual consultations through video, audio, and messaging. The solution supports appointment scheduling, digital prescriptions, remote patient monitoring, and seamless integration with existing healthcare systems while ensuring compliance with industry standards.",
             features: [
                 "Secure HD video and audio consultations with screen sharing",
                 "Appointment scheduling with automated reminders and virtual waiting rooms",
                 "Digital prescriptions with pharmacy integration",
                 "Encrypted chat and medical document sharing",
                 "Remote patient monitoring through wearable device integration",
                 "Role-based access control with HIPAA-compliant data security",
             ],
             technologies: [
                 "React",
                 "Angular",
                 "MVC",
                 ".NET",
                 "Azure",
                 "MS SQL Server",
                 "Node.js",
                 "Twilio",
                 "HIPAA Compliance",
                 "Github CICD",
             ],
 
             results:
                 "Improved access to quality healthcare, reduced appointment no-shows, enhanced patient engagement, and enabled efficient remote care delivery through a secure digital platform.",
             images: [
                 "assets/img/Portfolio/Telemedicine1.png",
                 "assets/img/Portfolio/Telemedicine2.png",
                 "assets/img/Portfolio/Telemedicine3.png",
                 "assets/img/Portfolio/Telemedicine4.png",
             ],
         },
         grocery1: {
             category: "Grocery",
             title: "Smart Inventory System",
             subtitle: "AI-powered inventory management for retail chains",
             overview:
                 "An intelligent inventory management system that leverages machine learning to predict demand, optimize stock levels, and reduce waste. The solution integrates with POS systems and IoT sensors for real-time inventory tracking.",
             features: [
                 "AI-driven demand forecasting and replenishment",
                 "Real-time inventory tracking with IoT sensors",
                 "Automated purchase order generation",
                 "Expiry date tracking and waste reduction alerts",
                 "Multi-location inventory synchronization",
                 "Supplier performance analytics",
             ],
             technologies: [
                 "Python",
                 "Azure",
                 "Azure Data Factory",
                 "SSIS",
                 "SSAS",
                 "MDM",
                 "SSRS",
                 "Power BI",
                 "SQL Server",
                 "Github CICD",
             ],
             results:
                 "Reduced inventory holding costs by 35%, decreased waste by 45%, and improved stock availability to 98%.",
             images: [
                 "assets/img/Portfolio/Inventory1.png",
                 "assets/img/Portfolio/Inventory2.png",
                 "assets/img/Portfolio/Inventory3.png",
                 "assets/img/Portfolio/Inventory4.png",
             ],
         },
         grocery2: {
             category: "Grocery",
             title: "Quick Commerce Platform",
             subtitle: "On-demand local shopping with ultra-fast delivery",
             overview:
                 "A high-performance quick commerce (Q-Commerce) platform designed to connect customers with nearby local shops for instant shopping and rapid delivery. The application enables real-time product availability, seamless ordering, and efficient last-mile fulfillment through web and mobile applications.",
             features: [
                 "Real-time product listing from nearby local stores",
                 "Ultra-fast order placement and checkout experience",
                 "Live inventory synchronization with local merchants",
                 "Smart store and product discovery based on location",
                 "Order tracking with real-time status updates",
                 "Push notifications for order updates and promotions",
             ],
             technologies: [
                 "Angular",
                 "React Native",
                 ".NET",
                 "Microsoft SQL Server",
                 "Firebase",
                 "Cloud Services",
                 "SignalR",
                 "RazorPay",
                 "Googlemaps API",
                 "Aadhar API",
                 "Github CICD",
             ],
             results:
                 "Enabled local retailers to go digital, reduced delivery times significantly, and improved customer engagement through fast, reliable, and convenient shopping experiences.",
             images: [
                 "assets/img/Portfolio/Dashboard.png",
                 "assets/img/Portfolio/Dashboard (1).png",
                 "assets/img/Portfolio/Dashboard (2).png",
                 "assets/img/Portfolio/Dashboard (3).png",
             ],
         },
 
         // data1: {
         //     category: "Data Solution",
         //     title: "Business Intelligence Dashboard",
         //     subtitle: "Real-time insights for data-driven decisions",
         //     overview:
         //         "A comprehensive business intelligence platform that transforms raw data into actionable insights. The solution provides interactive dashboards, automated reporting, and predictive analytics to help executives make informed decisions.",
         //     features: [
         //         "Real-time interactive dashboards",
         //         "Automated report generation and distribution",
         //         "Predictive analytics with ML models",
         //         "Data visualization with 50+ chart types",
         //         "Role-based access and data security",
         //         "Integration with 100+ data sources",
         //     ],
         //     technologies: [
         //         "Power BI",
         //         "Python",
         //         "SQL Server",
         //         "Azure ML",
         //         "DAX",
         //         "REST APIs",
         //     ],
         //     results:
         //         "Reduced reporting time by 80%, improved decision-making speed by 50%, and identified cost-saving opportunities worth $2M annually.",
         //     images: [
         //         "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit-crop",
         //         "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit-crop",
         //         "https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=400&h=300&fit-crop",
         //         "https://images.unsplash.com/photo-1543286386-713bdd548da4?w=400&h=300&fit-crop",
         //     ],
         // },
         data1: {
             category: "Data Engineering & Business Intelligence Solutions",
             title: "Enterprise Data Analytics & Intelligence Platform for Sellkro (Automotive Domain)",
             subtitle:
                 "Real-time, secure, and scalable data intelligence solution enabling smarter decisions across the vehicle ecosystem",
             overview:
                 "Alphurious Technologies designed and implemented an end-to-end data analytics and business intelligence solution for Sellkro, an India-based vehicle platform.The solution consolidates data from multiple operational sources, processes it through a modern cloud data pipeline, and delivers real-time insights, predictive analytics, and automated reporting to business stakeholders.The platform empowers Sellkro’s leadership, operations, and analytics teams with actionable insights, enabling data-driven decision-making, operational optimization, and future growth planning.",
             features: [
                 "Real-Time Interactive Dashboards",
                 "Automated Report Generation & Distribution",
                 "Predictive Analytics & Trend Forecasting",
                 "Advanced Data Visualization & Matrices",
                 "Role-Based Access Control & Data Security",
                 "Multi-Source Data Integration",
             ],
             technologies: [
                 "Power BI",
                 "Microsoft Azure Cloud Platform",
                 "SQL Server",
                 "Azure Data Factory (ADF)",
                 "Azure Data Warehouse",
                 "ETL Pipelines",
                 "Github CICD",
             ],
             results: [
                 "📊 Improved Decision-Making through real-time visibility into critical business metrics",
                 "⚙️ Operational Efficiency Increased by eliminating manual reporting and data silos ",
                 "⏱️ Faster Reporting Cycles with automated and scheduled insights",
                 "🔐 Enhanced Data Security & Compliance with role-based access control",
                 "📈 Future-Ready Analytics enabling predictive insights and scalable growth ",
                 "💰 Cost Optimization by leveraging cloud-native, scalable data architecture",
             ],
             images: [
                 "assets/img/Portfolio/Sellkro1.png",
                 "assets/img/Portfolio/Sellkro2.png",
                 "assets/img/Portfolio/Sellkro3.png",
                 "assets/img/Portfolio/Sellkro4.png",
             ],
         },
         automotive1: {
             category: "automotive",
             title: "Vehicle Marketplace Platform",
             subtitle:
                 "Cloud-native digital platform for buying and selling vehicles",
             overview:
                 "A scalable and secure vehicle marketplace application designed to enable seamless vehicle discovery, listing, and transaction management. The platform supports both web and mobile users and leverages Cloudflare’s global network for enhanced security, performance, and reliability.",
             features: [
                 "Vehicle listing and management for sellers and dealers",
                 "Advanced search and filtering for vehicles",
                 "Secure user authentication with role-based access control",
                 "Real-time order, inquiry, and lead management",
                 "Mobile-first experience for customers and delivery partners",
                 "High availability and DDoS protection using Cloudflare",
             ],
             technologies: [
                 "Angular",
                 "React Native",
                 ".NET Core",
                 "Microsoft SQL Server",
                 "CDN",
                 "Github CICD",
                 "REST APIs",
             ],
             results:
                 "Improved platform performance and reliability, ensured secure data transmission, and enabled scalable growth to handle high traffic volumes across web and mobile users.",
             images: [
                "assets/img/Portfolio/Vehicle1.png",
                "assets/img/Portfolio/Vehicle2.png",
                "assets/img/Portfolio/Vehicle3.png",
                "assets/img/Portfolio/Vehicle4.png",
             ],
         },
     };
//  submitContact(form: NgForm): void {
//    if (form.invalid) return;
 
//    this.portfolioService.submitContact(form.value).subscribe({
//      next: () => {
//        alert('Thank you! Your message has been sent.');
//        form.resetForm();
//      },
//      error: () => {
//        alert('Something went wrong. Please try again.');
//      }
//    });
//  }
     // 4. Helper to get the keys for *ngFor in HTML
     
     projectKeys = Object.keys(this.projects);
 
     // 5. Angular lifecycle hook for initial setup (like the original JS file's bottom code)
     ngOnInit(): void {
         // Scroll handling is complex in Angular without a routing solution,
         // but the original logic is translated to a method for easy use.
         this.setupScrollHandling();
         this.setupEscapeKeyModalClose();
     }
 
     // 6. Logic to open the project detail modal
     openModal(projectId: string): void {
      debugger;
         const project = this.projects[projectId];
         if (project) {
             this.selectedProject = project;
             this.isModalOpen = true;
             document.body.style.overflow = "hidden";
         }
     }
 
     // 7. Logic to close the project detail modal
     closeModal(): void {
         this.isModalOpen = false;
         this.selectedProject = null;
         document.body.style.overflow = "";
     }
 
     // 8. Logic to filter portfolio projects
     filterProjects(category: string): void {
         this.currentFilter = category;
     }
 
     // 9. Logic for the contact form submission
     handleSubmit(e: Event): void {
         e.preventDefault();
         alert("Thank you! Your message has been sent successfully.");
         // In a real Angular app, you would use HttpClient to send data to a backend.
         const form = e.target as HTMLFormElement;
         form.reset();
     }
 
     // 10. Implement original JavaScript event listeners in Angular style
     // app.component.ts
 
     // ... other code ...
 
     private setupScrollHandling(): void {
         document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
             anchor.addEventListener("click", (e) => {
                 e.preventDefault();
                 const href = anchor.getAttribute("href");
 
                 if (href) {
                     const target = document.querySelector(href);
 
                     // --- THIS IS THE CRUCIAL CHANGE ---
                     // 1. Check if target exists (not null)
                     // 2. Use 'instanceof' to narrow the type from Element to HTMLElement
                     if (target instanceof HTMLElement) {
                         // Now TypeScript knows 'target' has 'offsetTop'
                         window.scrollTo({
                             top: target.offsetTop - 70,
                             behavior: "smooth",
                         });
                     }
                 }
             });
         });
     }
 
     // ... rest of the code ...
 
     private setupEscapeKeyModalClose(): void {
         document.addEventListener("keydown", (e) => {
             if (e.key === "Escape" && this.isModalOpen) {
                 this.closeModal();
             }
         });
     }
}
